/* Universal Cart Drawer v2 */
(function() {
  if (window.__universalCartDrawerV2) return;
  window.__universalCartDrawerV2 = true;

  var fixStyle = document.createElement('style');
  fixStyle.textContent = '.cart-drawer__close{position:absolute;top:-2px;right:0;width:54px;height:54px;padding:15px;z-index:10;overflow:hidden}.cart-drawer__close svg{display:block;width:24px;height:24px}';
  document.head.appendChild(fixStyle);

  /* Flag to suppress theme's native drawer open after our add-to-cart */
  var _weHandledIt = false;

  function openDrawer() {
    var el = document.querySelector('cart-element[data-cart-drawer]');
    if (el == null) return;

    if (el.isCartDrawerLoaded !== true && typeof el.renderCartDrawer === 'function') {
      el.renderCartDrawer(false);
    }

    el.style.cssText = 'position:fixed !important;right:0 !important;top:0 !important;bottom:0 !important;left:auto !important;width:400px !important;max-width:95vw !important;z-index:99999 !important;visibility:visible !important;opacity:1 !important;content-visibility:visible !important;background:var(--bg,#fff) !important;overflow-y:auto !important;display:flex !important;flex-direction:column !important;transform:none !important;height:100% !important;box-shadow:-4px 0 20px rgba(0,0,0,0.15) !important;';

    el.classList.add('is-open');
    el.classList.remove('cv-h');
    document.body.classList.add('js-drawer-open-cart');
    el.isCartDrawerOpen = true;

    if (typeof el.getCart === 'function') {
      el.getCart();
    }
  }

  function closeDrawer() {
    var el = document.querySelector('cart-element[data-cart-drawer]');
    if (el == null) return;
    el.style.cssText = '';
    el.classList.remove('is-open');
    el.classList.add('cv-h');
    document.body.classList.remove('js-drawer-open-cart');
    el.isCartDrawerOpen = false;
  }

  window.openCartDrawerFix = openDrawer;

  /* Suppress theme:cart:added from re-opening drawer when we already opened it */
  document.addEventListener('theme:cart:added', function(e) {
    if (_weHandledIt) {
      e.stopImmediatePropagation();
    }
  }, true);

  /* Close handler - capture phase */
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('[data-cart-drawer-toggle], .cart-drawer__close');
    if (closeBtn == null) return;
    var el = document.querySelector('cart-element[data-cart-drawer]');
    if (el == null || el.classList.contains('is-open') !== true) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closeDrawer();
  }, true);

  /* Helper: add JSON then open */
  function addAndOpen(variantId, quantity, btn) {
    var origText = '';
    if (btn) {
      origText = btn.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'true');
      btn.textContent = 'Adding...';
    }
    _weHandledIt = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        btn.textContent = data.status ? (origText || 'Add To Cart') : 'Added!';
        if (data.status === undefined) setTimeout(function() { btn.textContent = origText || 'Add To Cart'; }, 1500);
      }
      if (data.status) return;
      openDrawer();
      setTimeout(function() { _weHandledIt = false; }, 2000);
    })
    .catch(function() {
      _weHandledIt = false;
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); btn.textContent = origText || 'Add To Cart'; }
    });
  }

  /* Helper: add FormData then open */
  function addFormAndOpen(formData, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', 'true'); }
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
    _weHandledIt = true;
    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); }
      if (response.status) { _weHandledIt = false; return; }
      openDrawer();
      setTimeout(function() { _weHandledIt = false; }, 2000);
    })
    .catch(function() {
      _weHandledIt = false;
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); }
    });
  }

  /* 1. React grid [data-jewelry-atc] */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-jewelry-atc]');
    if (btn == null) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var vid = btn.getAttribute('data-jewelry-atc');
    if (vid == null || vid === '') return;
    addAndOpen(vid, 1, btn);
  }, true);

  /* 2. Quickbuy click [data-add-to-cart] inside [data-quickbuy-form] */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn == null) return;
    var form = btn.closest('form[data-quickbuy-form]');
    if (form == null) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFormAndOpen(new FormData(form), btn);
  }, true);

  /* 3. Quickbuy form submit (backup) */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form == null || form.hasAttribute('data-quickbuy-form') !== true) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    addFormAndOpen(new FormData(form), btn);
  }, true);

  /* 4. product-form custom element (product pages) */
  if (window.customElements) {
    customElements.whenDefined('product-form').then(function() {
      var PF = customElements.get('product-form');
      if (PF == null || PF.prototype.__universalPatched === true) return;
      PF.prototype.__universalPatched = true;
      PF.prototype.addToCart = function(data) {
        addFormAndOpen(data, this.submitButton);
      };
    });
  }

  /* 5. Generic form[action*="/cart/add"] fallback */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form == null || form.tagName !== 'FORM') return;
    if (form.hasAttribute('data-quickbuy-form')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    addFormAndOpen(new FormData(form), btn);
  }, true);

})();
